import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/")({
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/portfolio/overview", search, replace: true });
	},
});
